export default {
  account: {
    academy_capitalized: "ACADEMIE",
    change_photo: "Changer de photo",
    currency: "Devise",
    currency_description: "Devise pour les frais de scolarité des étudiants et la paie des enseignants.",
    email_capitalized: "E-MAIL",
    first_name_capitalized: "PRENOM",
    language: "Langue",
    language_settings: "Paramètres de langue",
    last_name_capitalized: "NOM",
    personal_information: "Informations personnelles",
    plan_usage: "Plan et utilisation",
    policy: "Politique",
    policy_setting_before: "heures avant",
    policy_setting_cancel: "Annulation",
    policy_setting_cancel_subtitle: "Définissez combien d'heures à l'avance une demande d'annulation peut être effectuée pour les cours.",
    policy_subtitle: "Définissez combien d'heures à l'avance une demande de reprogrammation peut être effectuée pour les cours.",
    profile: "Profil",
    reschedule: "Reprogrammer",
    subscription: "Abonnement",
    subscription_info_contact: "{'Veuillez contacter yan@getfunclass.com pour gérer ou annuler votre abonnement. Merci !'}",
    subtitle: "Vous pouvez gérer les paramètres de votre compte ici.",
    title: "Paramètres du compte"
  },
  auth: {
    agency_name: "Centre de scolarité",
    agree_to: "J'accepte les",
    alreadyhasaccount: "Vous avez déjà un compte ?",
    confirmPassword: "Confirmer le mot de passe",
    createaccount: "Créer un compte",
    email: "E-mail",
    email_enter: "Entrez votre e-mail",
    email_send: "Envoyer un e-mail",
    firstname: "Prénom",
    firstname_student: "Prénom de l'étudiant",
    forgotpassword: "Mot de passe oublié ?",
    hasaccount: "Vous n'avez pas de compte ?",
    lastname: "Nom de famille",
    login: "Se connecter",
    loginbutton: "Se connecter",
    logout: "Se déconnecter",
    no_active_account: "Aucun compte actif trouvé avec les identifiants fournis",
    password: "Mot de passe",
    passwordreset: "Réinitialiser votre mot de passe",
    passwordresetbutton: "Réinitialiser le mot de passe",
    required: {
      agency_name: "Le nom de l'académie est requis",
      email: "L'e-mail est requis",
      email_exists: "Un compte avec cet e-mail existe déjà",
      first_name: "Le prénom est requis",
      invalid_email: "L'e-mail est invalide",
      last_name: "Le nom de famille est requis",
      password: "Le mot de passe est requis",
      password_length: "Le mot de passe doit comporter au moins 8 caractères",
      password_requirement: "Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial ({'@'} $ ! % * ? & #)."
    },
    reset: "Réinitialiser",
    signup: "S'inscrire",
    signup_subtitle: "Entrez vos identifiants pour créer un compte sur Funclass.",
    terms: "Conditions générales"
  },
  button: {
    archive: "Archiver",
    copy: "Copier !",
    delete: "Supprimer",
    edit: "Modifier",
    invite: "Inviter",
    save: "Enregistrer",
    submit: "Soumettre",
    unarchive: "Désarchiver"
  },
  course: {
    chinese_students: "Cette classe a des étudiants en Chine",
    class_name: "Nom de la classe",
    class_name_placeholder: "Entrez le nom de votre classe ici",
    class_settings: {
      account_type: "Type de compte",
      account_type_warning_non_gamified: "Les étudiants n'auront pas de compagnon et ne collecteront pas de XP/HP.",
      account_type_warning_setup: "Le type de gamification ne peut être défini qu'une seule fois lors de la création de la classe.",
      enable_breakout_room: "Activer la salle de répartition (désactive la connexion audio automatique)",
      gamified: "Ludifié",
      non_gamified: "Non ludifié",
      recording_exclude_webcam: "L’enregistrement n’inclut pas la webcam des élèves",
      title: "Paramètres de la classe"
    },
    create: "Ajouter une classe",
    delete: "supprimer",
    delete_confirmation: "Confirmation de suppression",
    delete_message: "Êtes-vous sûr de vouloir supprimer cette classe ?",
    delete_student: "Êtes-vous sûr de vouloir retirer cet élève de la classe ?",
    duration: "Durée",
    duration_time_unit: "minutes",
    edit: "Modifier la classe",
    filters: {
      active: "Classes actives",
      all: "Toutes les classes",
      archived: "Classes archivées"
    },
    join: "Rejoindre la classe",
    link_valid_for: "Ce lien est valable pendant {n} jour(s).",
    name_too_short: "Le nom du cours doit comporter au moins 2 caractères",
    no_content: {
      filtered: {
        subtitle: "Essayez de modifier les filtres.",
        title: "Aucune classe ici"
      },
      general: {
        teacher_subtitle: "Cliquez sur le bouton “Ajouter une classe” pour commencer !",
        teacher_subtitle_agency: "Aucun cours attribué pour l’instant. Veuillez attendre que votre académie vous en attribue un.",
        title: "Aucune classe créée pour le moment"
      }
    },
    notify: {
      archive_course_error: "Erreur lors de l’archivage du cours",
      archive_course_success: "Le cours {courseName} a été archivé avec succès !",
      copy_link_error: "Erreur lors de la copie du lien",
      copy_link_success: "Copié !",
      delete_course_error: "Erreur lors de la suppression du cours",
      edit_course_error: "Erreur lors de la modification du cours",
      required_fields: "Veuillez remplir les champs obligatoires",
      start_meeting_error: "Erreur lors du démarrage de la réunion. Veuillez réessayer.",
      unarchive_course_error: "Erreur lors de la désarchivage du cours",
      unarchive_course_success: "Le cours {courseName} a été désarchivé avec succès !"
    },
    please_resubscribe: "Veuillez vous réabonner à Funclass pour continuer.",
    progress: "Progression",
    resubscribe: "Se réabonner",
    share: "Partager la classe",
    shareText: "Partagez le lien pour inviter vos élèves à rejoindre la classe !",
    start: "Démarrer la classe",
    subscription_expired: "Abonnement expiré",
    title: "Tableau de bord de la classe",
    view: "Voir la classe"
  },
  datetime: {
    days: {
      friday: "Vendredi",
      initials: {
        friday: "V",
        monday: "L",
        saturday: "M",
        sunday: "M",
        thursday: "J",
        tuesday: "V",
        wednesday: "S"
      },
      monday: "Lundi",
      saturday: "Samedi",
      short: {
        friday: "Ven",
        monday: "Lun",
        saturday: "Sam",
        sunday: "Dim",
        thursday: "Jeu",
        tuesday: "Mar",
        wednesday: "Mer"
      },
      sunday: "Dimanche",
      thursday: "Jeudi",
      tuesday: "Mardi",
      wednesday: "Mercredi"
    },
    time_format: "à {time}",
    today: "Aujourd’hui",
    tomorrow: "Demain",
    yesterday: "Hier"
  },
  homework: {
    assign: {
      assignment_info: {
        attach_files: "Joindre des fichiers",
        attachments: "Fichiers joints",
        choose_class: "Choisissez une classe à attribuer",
        class: "Classe",
        description: "Description des devoirs",
        due_date: "Date limite (votre heure locale)",
        due_date_past: "La date limite doit être dans le futur",
        submission_required: "Remise requise",
        title: "Titre",
        title_required: "Le titre est requis"
      },
      confirm_leave: "Êtes-vous sûr de vouloir quitter cette page ? Vos modifications ne seront pas enregistrées.",
      create: "Attribuer",
      remove_attachment: "Supprimer",
      title: "Attribuer un devoir",
      upload_attachments: "Téléchargez votre/vos fichier(s) joint(s)"
    },
    dashboard: {
      archived: "Archivé",
      create: "Attribuer un devoir",
      delete_button: "Supprimer {assignment}",
      delete_confirmation: "Confirmation de suppression",
      delete_message: "Êtes-vous sûr de vouloir supprimer ce devoir ?",
      due: "Date limite",
      filters: {
        all_classes: "Toutes les classes",
        all_graded: "Toutes notées",
        any_status: "N’importe quel statut",
        archived: "Archivé",
        assigned: "Attribué",
        no_submission_needed: "Aucune remise requise",
        to_be_graded: "À noter"
      },
      graded_on: "Noté le",
      header: {
        class: "Classe",
        due: "Date limite",
        status: "Statut",
        title: "Titre"
      },
      na: "N/A",
      no_content: {
        completed: {
          subtitle: "Vos devoirs terminés en attente de correction apparaîtront ici.",
          title: "Aucun devoir terminé"
        },
        filtered: {
          subtitle: "Essayez de modifier les filtres pour trouver le devoir recherché.",
          title: "Aucun devoir ne correspond à vos filtres"
        },
        general: {
          subtitle: "Cliquez sur le bouton “Attribuer un devoir” pour commencer !",
          title: "Aucun devoir créé pour le moment"
        },
        graded: {
          subtitle: "Vos devoirs notés apparaîtront ici.",
          title: "Aucun devoir noté"
        },
        pending: {
          subtitle: "Revenez plus tard pour de nouveaux devoirs.",
          title: "Aucun devoir en attente"
        }
      },
      no_due_date: "Pas de date limite",
      notify: {
        archive_assignment_error: "Échec de l’archivage du devoir. Veuillez réessayer plus tard.",
        archive_assignment_success: "Devoir archivé avec succès !",
        delete_assignment_error: "Échec de la suppression du devoir. Veuillez réessayer plus tard.",
        delete_assignment_success: "Devoir supprimé avec succès !",
        unarchive_assignment_error: "Échec de la désarchivage du devoir. Veuillez réessayer plus tard.",
        unarchive_assignment_success: "Devoir désarchivé avec succès !"
      },
      num_submitted: "{submitted} / {total} remis",
      submission_not_required: "Aucune remise requise",
      submit: "Soumettre",
      submitted_on: "Soumis le",
      tabs: {
        completed: "Terminé",
        graded: "Noté",
        pending: "En attente"
      },
      title: "Tableau de bord des devoirs",
      view_submission: "Voir"
    },
    details: {
      attach_files: "Joindre des fichiers",
      attachments: "Fichiers joints",
      delete_button: "Supprimer {assignment}",
      delete_confirmation: "Confirmation de suppression",
      delete_message: "Êtes-vous sûr de vouloir supprimer ce devoir ?",
      description: "Description",
      download_attachment: "Télécharger",
      due: "Date limite",
      edit_homework: "Modifier le devoir",
      edit_submission: "Modifier la remise",
      graded_on: "Noté le",
      homework_details: "Détails du devoir",
      homework_submission: "Remise du devoir",
      not_submitted: "Non remis",
      post_submission_success: "Remise envoyée avec succès !",
      remove_attachment: "Supprimer",
      reward: "Récompense :",
      student_submissions: "Remises des élèves",
      submission_not_required: "Aucune remise requise",
      submit_homework: "Soumettre",
      submitted_on: "Soumis le",
      teacher_feedback: "Commentaires du professeur",
      title: "Devoir",
      upload_attachments: "Téléchargez votre/vos fichier(s) joint(s)",
      view_submission: "Voir",
      your_submission: "Votre remise"
    },
    edit: {
      assignment_info: {
        attach_files: "Joindre des fichiers",
        attachments: "Fichiers joints",
        choose_class: "Choisissez une classe à attribuer",
        class: "Classe",
        description: "Description des devoirs",
        due_date: "Date limite (votre heure locale)",
        due_date_past: "La date limite doit être dans le futur",
        submission_required: "Remise requise",
        title: "Titre",
        title_required: "Le titre est requis"
      },
      confirm_leave: "Êtes-vous sûr de vouloir quitter cette page ? Vos modifications ne seront pas enregistrées.",
      keep_attachment: "Conserver",
      remove_attachment: "Supprimer",
      save_changes: "Enregistrer les modifications",
      title: "Modifier le devoir",
      upload_attachments: "Téléchargez votre/vos fichier(s) joint(s)"
    },
    edit_submission: {
      attach_files: "Joindre des fichiers",
      attachments: "Fichiers joints",
      description: "Description",
      download_attachment: "Télécharger",
      due: "Date limite",
      edit_submission_success: "Remise modifiée avec succès !",
      homework_details: "Détails du devoir",
      keep_attachment: "Conserver",
      last_submitted_on: "La dernière remise a été effectuée le",
      remove_attachment: "Supprimer",
      resubmit_homework: "Soumettre à nouveau",
      title: "Modifier la remise",
      upload_attachments: "Téléchargez votre/vos fichier(s) joint(s)",
      your_submission: "Votre remise"
    },
    submission_details: {
      attach_files: "Joindre des fichiers",
      attachments: "Fichiers joints",
      description: "Remise du devoir",
      download_attachment: "Télécharger",
      graded_on: "Noté le",
      remove_attachment: "Supprimer",
      reward: "Récompense :",
      reward_xp: "Récompenser avec XP",
      reward_xp_placeholder: "Saisissez le montant de XP ici",
      rewarding: "Attribution en cours",
      save_reward: "Enregistrer",
      save_reward_success: "Montant de la récompense enregistré avec succès !",
      send_feedback: "Envoyer",
      send_feedback_success: "Commentaires envoyés avec succès !",
      submitted_on: "Soumis le",
      teacher_feedback: "Commentaires du professeur",
      title: "Devoir",
      your_feedback: "Vos commentaires"
    }
  },
  inclass: {
    endLesson: "Souhaitez-vous terminer la leçon ?"
  },
  inclassQuiz: {
    dragMe: "Faites-moi glisser",
    folderTitle: "Sélectionner un dossier",
    modeTitle: "Sélectionner un mode",
    noQuizYet1: "Aucun quiz pour le moment.",
    noQuizYet2: "Veuillez en créer un à l’extérieur de la classe.",
    quizRuleDescription1: "• Pour chaque bonne réponse des élèves, le monstre perd une vie",
    quizRuleDescription2: "• Pour chaque mauvaise réponse des élèves, ils perdent une vie",
    quizRuleDescription3: "•⁠ À la fin du quiz, les élèves doivent avoir plus de vies que le monstre pour gagner le combat !",
    quizRuleDescriptionStudent1: "• Pour chaque bonne réponse, le monstre perd une vie",
    quizRuleDescriptionStudent2: "• Pour chaque mauvaise réponse, tu perds une vie",
    quizRuleDescriptionStudent3: "•⁠ À la fin du quiz, tu dois avoir plus de vies que le monstre pour gagner le combat !",
    studentsJoinedCount: "élèves se sont joints",
    teacherPreStartQuiz: "Vous êtes sur le point de lancer le quiz...",
    title: "Sélectionner un quiz"
  },
  lesson_status: {
    cancelled: "Annulé",
    completed: "Terminé",
    completed_absence: "Terminé (Absence)",
    no_show: "Absent",
    ongoing: "En Cours",
    rescheduled: "Replanifié",
    scheduled: "Planifié",
    started: "Commencé"
  },
  meeting: {
    attention_tracker_disable: "Désactiver le suivi de l’attention",
    attention_tracker_enable: "Activer le suivi de l’attention",
    button_join_quiz: "Rejoindre le quiz actif"
  },
  misc: {
    handbook: "Manuel"
  },
  my_calendar: {
    abort: "Annuler",
    accept_request: "Accepter la Demande",
    all_members: "Tous les membres",
    attendees: "Participants",
    cancel: "Annuler",
    cancel_lesson: "Annuler le cours",
    cancel_lesson_title: "Annuler le Cours",
    cancellation_constraint: "Toutes les annulations doivent être effectuées au moins {hours} heures à l’avance",
    confirm: "Confirmer",
    confirm_approve_reschedule: "Êtes-vous sûr de vouloir approuver cette demande de reprogrammation ?",
    course: "Cours",
    date: "Date",
    date_time: "Date et Heure",
    day: "Jour",
    from: "de",
    from_admin: "Depuis Admin",
    join: "Rejoindre",
    month: "Mois",
    next: "Suivant",
    notes: "Notes",
    notify: {
      approve_reschedule_request_error: "Échec de l'approbation de la demande de reprogrammation. Veuillez réessayer.",
      approve_reschedule_request_success: "Demande de reprogrammation approuvée avec succès.",
      request_cancel_error: "Échec de l'envoi de la demande d'annulation de leçon. Veuillez réessayer.",
      request_cancel_success: "Demande d'annulation de leçon envoyée avec succès.",
      request_reschedule_error: "Échec de la demande de reprogrammation de leçon. Veuillez réessayer.",
      request_reschedule_success: "Demande de reprogrammation de leçon envoyée avec succès."
    },
    previous: "Précédent",
    reschedule: "Reprogrammer",
    reschedule_constraint: "La demande de reprogrammation doit être faite au moins {hours} heures à l’avance",
    reschedule_lesson_title: "Reprogrammer le Cours",
    reschedule_note: "Note de Reprogrammation",
    reschedule_requests: "Demandes de Reprogrammation",
    save: "Enregistrer",
    send_request: "Envoyer la demande",
    students: "Étudiants",
    subtitle: "Vous pouvez consulter et gérer tous vos cours et votre disponibilité ici.",
    suggest_alternative_title: "Suggérer une Alternative",
    teachers: "Professeurs",
    title: "Mon Calendrier",
    to: "à",
    today: "Aujourd’hui",
    view_lesson: "Voir le Cours",
    week: "Semaine",
    your_requests: "Vos demandes"
  },
  my_items: {
    change_pet_button: "Changer d'animal",
    confirm_button: "Confirmer",
    feed_button: "Nourrir",
    go_to_shop_button: "Aller à la boutique",
    no_content: {
      accessories: {
        subtitle: "Tu n'as encore rien acheté.",
        title: "Aucun accessoire disponible"
      },
      food: {
        subtitle: "Tu n'as encore rien acheté.",
        title: "Aucune nourriture disponible"
      },
      pets: {
        subtitle: "Va à la boutique pour acheter des animaux.",
        title: "Aucun animal disponible"
      }
    },
    pet_reactions: {
      accessory: [
        "C’est parfait pour moi !",
        "Je suis incroyable avec ça !",
        "Je crois que j’ai trouvé mon nouveau style !",
        "Ça me va trop bien !",
        "Je déchire avec cet accessoire !",
        "Je n’en reviens pas comme ça me va bien !",
        "Ce style est définitivement fait pour moi !",
        "C’est totalement mon style !",
        "Regarde-moi, je suis fabuleux !",
        "Je me sens super stylé avec ça !",
        "Oh waouh, je suis magnifique !",
        "C’était fait pour moi !",
        "Je me sens super élégant maintenant !",
        "Là c’est de la mode !",
        "Je suis trop stylé !",
        "Trop mignon pour être vrai !",
        "Je crois que c’est mon nouveau préféré !",
        "Je me sens comme une superstar !",
        "Je suis né pour porter ça !",
        "M’habiller c’est trop amusant !"
      ],
      after_eating: [
        "Miam, ce {food_name} était délicieux ! 😋",
        "J’adore le {food_name} ! ❤️",
        "Merci pour le {food_name} ! 😊",
        "{food_name} ! Délicieux ! 😋"
      ],
      full: [
        "Je suis rassasié ! 😋",
        "Je n’ai plus faim ! 😌",
        "J’en ai eu assez, merci ! 🙏"
      ],
      hungry: [
        "J’ai trop faim ! 😢",
        "Je peux avoir à manger, s’il te plaît ? 🍽️",
        "Mon ventre gargouille ! 🥺",
        "Nourris-moi, s’il te plaît ! 🙏"
      ]
    },
    subtitle: "Voici mes objets !",
    tabs: {
      accessories: "Accessoires",
      food: "Nourriture",
      pets: "Animaux"
    },
    take_off_button: "Enlever",
    title: "Mes objets"
  },
  notifications: {
    empty: "Aucune notification",
    messages: {
      ASSIGNMENT_CREATED: "{name} a créé le devoir {description}",
      ASSIGNMENT_GRADED: "{name} a noté le devoir {description}",
      ASSIGNMENT_SUBMITTED: "{name} a soumis un devoir pour {description}",
      ENROLLMENT_STUDENT: "{name} s’est inscrit à {description}",
      ENROLLMENT_STUDENT_AGENCY: "{name} s’est enregistré à {description}",
      ENROLLMENT_TEACHER_AGENCY: "{name} s’est inscrit dans votre agence",
      LESSON_CANCELLED: "{name} a annulé une leçon pour {description}",
      LESSON_CANCEL_REQUESTED: "{name} a demandé l’annulation d’une leçon pour {description}",
      LESSON_RESCHEDULED: "{name} a reprogrammé une leçon pour {description}",
      LESSON_RESCHEDULE_REQUESTED: "{name} a demandé à reprogrammer une leçon pour {description}",
      LESSON_REVIEWED: "{name} a évalué votre {description}",
      STUDENT_REVIEWED: "{name} vous a laissé un commentaire pour la classe {description}"
    },
    title: "Notifications"
  },
  onboarding_zoom: {
    student: {
      welcome_title: 'Bienvenue sur Funclass ',
      welcome_subtitle: "Préparez votre cours en 2 étapes simples!",
      title_step_1: "Connectez Zoom pour commencer à apprendre",
      description_step_1_1: "Funclass utilise Zoom pour les cours. Rejoignez directement depuis Funclass—plus besoin de liens!",
      description_step_1_2: "Gagnez des récompenses grâce à vos cours Zoom tout en apprenant et en faisant évoluer votre avatar!",
      connect_button: "Connecter Zoom",
      skip_button: "Passer pour l'instant",
      watch_tutorial: "Regarder la vidéo tutoriel",
      tutorial_subtitle: "Apprenez à utiliser Funclass en seulement 1 minute",
      finish_onboarding_button: "Commencer à apprendre",
      handbook_button: "Lire le guide"
    },
    teacher: {
    },
  },
  onboarding: {
    course: {
      browser_notice: [
        {
          acknowledgement_text: "J’ai lu et compris.",
          body: [
            "",
            "Pour des performances et une compatibilité optimales, veuillez utiliser l’un des navigateurs pris en charge ci-dessous 🚀",
            "🔹 Ordinateur de bureau/portable : Chrome, Firefox ou Edge (dernière version)",
            "🔹 Mobile (iOS 12.2+) : Safari",
            "🔹 Mobile (Android 10.0+) : Chrome"
          ],
          header: [
            "⚠️ Veuillez lire : Navigateurs pris en charge"
          ]
        }
      ],
      egg_unhatched: "Votre animal n’a pas encore éclos. Gagnez des XPs dans votre classe pour atteindre le __Niveau {level}__ et faire éclore votre œuf !",
      teacher: [
        {
          body: [
            "Sur Funclass, les enseignants peuvent récompenser les efforts et les progrès des élèves avec des XPs (points d’expérience), comme dans un jeu !"
          ],
          button_text: "Suivant",
          header: [],
          title: "Bienvenue sur Funclass 🎉 !"
        },
        {
          body: [
            "montrer leur processus d’apprentissage",
            "faire évoluer leurs animaux magiques",
            "déverrouiller plus de surprises !"
          ],
          button_text: "Suivant",
          header: [
            "N’abusez pas des XPs à moins que les élèves montrent de réels efforts et progrès.",
            "Avec les XPs, les élèves peuvent..."
          ]
        },
        {
          body: [
            "Participation active en classe",
            "Quiz en classe",
            "Remise de devoirs",
            "Bonne préparation du cours",
            "et d’autres comportements d’apprentissage positifs..."
          ],
          button_text: "Suivant",
          header: [],
          title: "Vous pouvez récompenser les élèves pour..."
        },
        "",
        {
          body: [
            "Lisez le Manuel Funclass pour découvrir des astuces et bonnes pratiques."
          ],
          header: []
        }
      ]
    },
    navigation: {
      finish: "Terminer",
      next: "Suivant",
      skip_now: "Passer pour le moment"
    }
  },
  profile: {
    avatar_actions: {
      my_items: "Mes éléments",
      pet_guide: "Guide des animaux",
      shop: "Boutique"
    },
    avatar_messages: {
      first_xp: "Waouh ! Tu as gagné {lastXP} XPs lors de ta dernière leçon. Il ne te reste que {xpToNextLevel} XPs avant que je n’éclose. Je me demande à quoi je vais ressembler 🐣",
      hungry: "J’ai faim 🥺. Gagne de la nourriture en classe pour me nourrir.",
      level_up: "Waouh ! Tu as gagné {lastXP} XPs lors de ta dernière leçon. Il ne te reste que {xpToNextLevel} XPs pour atteindre ton prochain niveau. Continue comme ça !",
      pet_gone_generic: "Malheureusement, ton animal a disparu... 💔",
      pet_gone_named: "Malheureusement, {petName} a disparu... 💔",
      pet_revive_hint_generic: "Rassemble au moins 100 HPs pour faire revivre ton animal.",
      pet_revive_hint_named: "Rassemble au moins 100 HPs pour faire revivre {petName}.",
      pet_revived: "Merci de t’être donné du mal pour me retrouver ! Tu m’as manqué ! Maintenant tu peux me nourrir 🙂",
      welcome_back: "Salut {name}, bon retour ! 👋 Je suis prêt à apprendre quelque chose de nouveau avec toi aujourd’hui ! 📚✨",
      welcome_new: "Salut {name} 👋, enchanté de te rencontrer ! Je suis ton compagnon d’apprentissage {petName}. Gagne des XPs en classe pour que je puisse éclore ! 🐣"
    },
    coin_modal: {
      earned_coins: "Waouh ! Tu as gagné {rewardAmount} FunCoins !",
      shop_button: "Aller à la boutique"
    },
    feedback_modal: {
      description: "Merci d’évaluer ton expérience de cours ci-dessous",
      label: "Pourquoi donnes-tu cette note ?",
      lesson_not_ended: "Le cours n’est pas terminé ?",
      no_rating: "Pas de note",
      rating_format: "{rating}/5 étoiles",
      rules: {
        max: "Le commentaire doit comporter moins de 300 caractères",
        min: "Le commentaire doit comporter plus de 10 caractères",
        required: "Le commentaire est requis"
      },
      submit_button: "Envoyer le commentaire",
      title: "Retour sur le cours"
    },
    level_up_modal: {
      submit_button: "Soumettre"
    },
    pet_letter: {
      letter_title_generic: "Lettre de ton animal",
      letter_title_named: "Lettre de {petName}",
      open_button: "Ouvrir",
      paragraph_1: "C’était vraiment sympa de te connaître et d’être ton compagnon d’apprentissage. J’ai adoré apprendre avec toi. Mais dernièrement, je me suis senti un peu ignoré 💔",
      paragraph_2: "Alors, j’ai décidé de partir un moment pour trouver un environnement plus attentionné. Rassemble 200 pièces pour acheter une potion dans la boutique et me retrouver.",
      paragraph_3: "J’ai hâte de te revoir bientôt !",
      received_title_generic: "Tu as reçu une lettre de ton animal",
      received_title_named: "Tu as reçu une lettre de {petName}",
      signature: "Affectueusement,\n{petName}"
    },
    revive_pet_modal: {
      revive_button: "Réanimer",
      revive_message_generic: "Tu as rassemblé 100 HPs 🎉\nTu peux maintenant faire revivre ton animal.",
      revive_message_named: "Tu as rassemblé 100 HPs 🎉\nTu peux maintenant faire revivre {petName}.",
      title: "Récompense"
    },
    title: "Ma maison",
    your_classes: "Tes cours"
  },
  quiz: {
    create: "Créer un quiz",
    create_description: "Description du quiz",
    create_name: "Nom du quiz",
    delete: "supprimer",
    delete_confirmation: "Confirmation de suppression",
    delete_message: "Es-tu sûr de vouloir supprimer ce quiz ?",
    edit: {
      add_alt_answer: "Ajouter une réponse alternative",
      add_answer: "Ajouter une réponse",
      add_question: "Ajouter une question",
      delete_message: "Es-tu sûr de vouloir supprimer cette question ?",
      delete_question: "Supprimer la question",
      save_question: "Enregistrer les questions",
      title: "Modifier le quiz"
    },
    edit_questions: "Modifier les questions",
    folder: {
      create: "Créer un dossier",
      create_name: "Nom du dossier",
      delete: "Supprimer le dossier",
      delete_confirmation: "Confirmation de suppression",
      delete_message: "Es-tu sûr de vouloir supprimer ce dossier ? Cela supprimera tous les quiz qu’il contient.",
      edit: "Modifier le dossier",
      name_limit: "Le nombre de caractères ne peut pas dépasser 50",
      name_not_empty: "Le nom du dossier ne peut pas être vide",
      save: "Enregistrer le dossier",
      title: "Tableau de bord des quiz"
    },
    name_limit: "Le nombre de caractères ne peut pas dépasser 50",
    name_not_empty: "Le nom du quiz ne peut pas être vide",
    save: "Enregistrer le quiz",
    title: "Tableau de bord des quiz"
  },
  recording: {
    delete_confirmation: "Es-tu sûr de vouloir supprimer cet enregistrement ?"
  },
  scheduling: {
    edit: {
      error: "Une erreur est survenue lors de la mise à jour de l’événement",
      options: {
        current: "Cette leçon",
        future: "Cette leçon et les suivantes",
        title_delete: "Sélectionner les événements à supprimer",
        title_edit: "Sélectionner les événements auxquels appliquer les modifications"
      },
      title: "Modifier une leçon planifiée"
    },
    end_date: "Date de fin",
    lesson_time: "Heure de la leçon",
    lesson_time_info: "Sélectionne ton heure locale. Nous ajustons automatiquement l’heure au fuseau horaire des élèves.",
    recurrence: {
      biweekly: "Toutes les 2 semaines",
      custom: "Personnalisé",
      daily: "Quotidien",
      label: "Répétition",
      none: "Aucune",
      occurs_on: "Se produit le",
      repeat_every: "Répéter tous les",
      time_unit_day: "jour | jours",
      time_unit_week: "semaine | semaines",
      weekly: "Hebdomadaire"
    },
    reminder: {
      hours_before: "{n} heure avant | {n} heures avant",
      label: "Rappel pour les élèves"
    },
    start_date: "Date de début"
  },
  shop: {
    buy_now_button: "Acheter maintenant",
    buy_pet_button: "Acheter un animal",
    cancel_button: "Annuler",
    confirm_button: "Confirmer",
    level_constraint: "Atteignez le niveau {level} pour débloquer cet objet",
    no_content: {
      accessories: {
        subtitle: "Revenez plus tard pour plus d'objets.",
        title: "Aucun accessoire disponible"
      },
      food: {
        subtitle: "Revenez plus tard pour plus d'objets.",
        title: "Aucune nourriture disponible"
      },
      pets: {
        subtitle: "Revenez plus tard pour plus d'animaux.",
        title: "Aucun animal disponible"
      },
      wallpapers: {
        subtitle: "Revenez plus tard pour plus de fonds d'écran.",
        title: "Aucun fond d'écran disponible"
      }
    },
    notify: {
      pet_name_required: "Veuillez entrer un nom pour l'animal"
    },
    pet_name: "Nom de l'animal",
    pet_name_prompt: "Donnez un nom à votre animal !",
    subtitle: "Vous pouvez acheter des objets pour votre animal ici !",
    title: "Magasin"
  },
  sidebar: {
    actions: {
      account_settings: "Paramètres du compte",
      logout: "Se déconnecter"
    },
    activities: {
      homework: "Devoirs",
      quiz: "Quiz",
      short_title: "Act",
      title: "Activités"
    },
    agency_name_placeholder: "Votre établissement",
    courses: {
      calendar: "Calendrier",
      courses: "Cours",
      history: "Historique",
      short_title: "Cours",
      title: "Cours"
    },
    general: {
      home: "Accueil",
      short_title: "Général",
      students: "Élèves",
      teachers: "Enseignants",
      title: "Général"
    }
  },
  understandingCheck: {
    start: "Vous êtes sur le point de lancer le test de compréhension",
    student: "Comment vous sentez-vous en ce moment ?",
    studentButtonNo1: "Hmm 🤔️",
    studentButtonNo2: "Un peu confus.",
    studentButtonYes1: "Bien ! 😄",
    studentButtonYes2: "J’ai compris.",
    teacher: "Comment les élèves se sentent en ce moment"
  },
  upload: {
    agency_logo_upload: "Téléversez le logo de votre établissement",
    drag_and_drop: "ou glissez-déposez",
    photo_upload: "Téléversez votre image",
    pick_file: "Choisir un fichier",
    square_image: "Image carrée recommandée.",
    upload: "Téléverser",
    upload_file: "Téléverser un fichier",
    upload_file_type: "Seuls les formats {formats} sont acceptés."
  },
  viewClass: {
    absence: "Absence",
    addMore: "Ajouter plus d'élèves",
    addStudent: "Inviter un élève",
    addStudents: "Ajouter des élèves",
    attendance: "Présence",
    date: "Date",
    download_recording: "Télécharger l'enregistrement",
    email: "Adresse e-mail",
    enterEmail: "Entrez l'adresse e-mail de l'élève ici",
    feedback_button: "Retour d'information",
    invite: "Inviter",
    lesson: "Leçon",
    notEmpty: "Le champ ne peut pas être vide",
    notValid: "L'e-mail n'est pas valide",
    recording_button: "Enregistrement",
    student_name: "Nom de l'élève",
    tabs: {
      course_material: "Diapositives en classe",
      lesson_history: "Historique des leçons",
      student_list: "Liste des élèves"
    },
    xps_earned: "XP gagnés"
  }
};
